import RouteRepository from "@domain/repositories/RouteRepository";
import UseCase from "@domain/UseCase";
import { Route } from "@domain/models/Route";

type Input = {
  routeId: Route["id"];
  data: Partial<Route>;
};

type Output = Promise<Route>;

export class UpdateRouteUseCase implements UseCase<Input, Output> {
  constructor(private readonly routeRepository: RouteRepository) {}

  execute({ routeId, data }: Input) {
    return this.routeRepository.update(routeId, data);
  }
}
